module.exports = __webpack_public_path__ + "img/thumbsup_facebook_icon.d038b539.svg";